<template>
  <div>
    <div v-if="type=='edit'">
      <template v-if="extendMetaData != null && extendMetaData.length != 0">
        <el-divider><span style="color:#409eff">扩展信息</span></el-divider>
        <template v-for="item in extendMetaData">
          <el-form-item v-if="item.type == 1"
                        :prop="item.code"
                        :label="item.label"
                        :key="item.id"
                        :rules="[
                {
                  required:
                    item.isRequired == null || item.isRequired == 0
                      ? false
                      : true,
                  message: '请输入' + item.label,
                  trigger: 'blur',
                },
                {
                  max: item.maxSize == null ? 100 : item.maxSize,
                  message: '不能超过' + item.maxSize + '个字符',
                  trigger: 'blur',
                },
              ]">
            <el-input v-model="data[item.code]"
                      :placeholder="'请输入' + item.label"
                      style="width:200px"
                      @blur="change"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item v-if="item.type == 2"
                        :prop="item.code"
                        :label="item.label"
                        :key="item.id"
                        :rules="[
                {
                  required:
                    item.isRequired == null || item.isRequired == 0
                      ? false
                      : true,
                  message: '请选择' + item.label,
                  trigger: 'blur',
                },
              ]">
            <el-select style="width:200px"
                       :ref="item.code"
                       v-model="data[item.code]"
                       :placeholder="'请选择' + item.label"
                       @change="change"
                       clearable
                       filterable>
              <el-option v-for="i in item.dicts"
                         :key="i.id"
                         :label="i.name"
                         :value="i.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="item.type == 3"
                        :prop="item.code"
                        :label="item.label"
                        :key="item.id"
                        :rules="[
                {
                  required:
                    item.isRequired == null || item.isRequired == 0
                      ? false
                      : true,
                  message: '请输入' + item.label,
                  trigger: 'blur',
                },
                {
                  max: item.maxSize == null ? 100 : item.maxSize,
                  message: '不能超过' + item.maxSize + '个字符',
                  trigger: 'blur',
                },
              ]">
            <el-input v-model="data[item.code]"
                      type="textarea"
                      :rows="2"
                      :placeholder="'请输入' + item.label"
                      style="width:200px"
                      @blur="change"
                      clearable>
            </el-input>
          </el-form-item>
        </template>
      </template>
    </div>
    <!--:type="item.value.indexOf('\n')>-1?'textarea':'text'" -->
    <div v-if="type=='view'">
      <template v-if="extendData != null && extendData.length != 0">
        <el-tabs  type="card">
    <el-tab-pane label="扩展信息">
       <el-descriptions  :column="3" style="cursor:pointer;margin-bottom:12px" size="mini" border>
           
           <template v-for="(item, index) in extendData">
    <el-descriptions-item :label="item.label" :labelStyle='labelStyle' :key="index" v-if="item.value !== ''&&item.value!=null">{{ item.value }}</el-descriptions-item>
  </template>
       </el-descriptions>
       
    </el-tab-pane>
  </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'esExtend',
  props: ['extendMetaData', 'extendData', 'idName', 'idValue', 'type'],
  data () {
    return {
      //label样式
      labelStyle: { 'width': '120px' },
      data: {}
    }
  },
  watch: {
    extendData () {
      this.data = {}
      if (this.extendData != null && this.extendData.length > 0) {
        this.extendData.forEach(e => {
          this.$set(this.data, e.code, e.valueCode == null ? e.value : e.valueCode)
        })
      }
    },
  },
  methods: {
    change () {
    
      let d = []
      this.extendMetaData.forEach((ele) => {
        let o = new Object()
        o[this.idName] = this.idValue
        o.code = ele.code
        o.label = ele.label
        if (ele.type == 2) {//列表
          o.valueCode = this.data[ele.code]
          let obj = ele.dicts.find((item) => {
            return o.valueCode == item.value
          })
          o.value = (obj == null ? null : obj.name)
        } else {
          o.value = this.data[ele.code]
        }
        d.push(o)
      })
      this.$emit('changeData', d, this.data)
    },
  },
}
</script>

<style scoped>
</style>